export default {
  title: {
    id: 'bo_sellers-orders-title',
    defaultMessage: 'Orders',
  },
  navigation: {
    id: 'bo_sellers-orders-tabs_bar',
    defaultMessage: 'Orders tabs',
  },
  tabNew: {
    id: 'bo_sellers-orders-new_orders_tab',
    defaultMessage: 'New Orders',
  },
  tabPending: {
    id: 'bo_sellers-orders-pending_orders_tab',
    defaultMessage: 'Pending Orders',
  },
  tabNeedingResponse: {
    id: 'bo_sellers-orders-needing_response_orders_tab',
    defaultMessage: 'Needing Response Orders',
  },
  tabAll: {
    id: 'bo_sellers-orders-all_orders_tab',
    defaultMessage: 'All orders',
  },
  actionCreateBackShipLabel: {
    id: 'bo_sellers-orders-create_back_ship_label',
    defaultMessage: 'Create BackShip Label',
  },
  actionImport: {
    id: 'bo_sellers-orders-import_csv',
    defaultMessage: 'Import CSV file',
  },
  actionExport: {
    id: 'bo_sellers-orders-export_csv',
    defaultMessage: 'Export CSV file',
  },
} as const
